<template>
	<div class="advert-manage-container">1</div>
</template>

<script>
	export default {
		data() {
			return {};
		},
	};
</script>

<style lang="scss" scoped>
	.advert-manage-container {
		padding: 20px;
		text-align: left;
	}
</style>
